import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import useDialog from 'hooks/useDialog';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';

const WishlistDialog = dynamic(
  () => import('components/Wishlist/WishlistDialog'),
  {
    ssr: false,
  }
);

const WishlistSuggestion = ({
  description = placeholder('descriptions.wishlistSuggestions'),
  gaEventCategory,
  title = placeholder('titles.wishlistSuggestions'),
}) => {
  const { showDialog } = useDialog();

  const onWishlistButtonClick = () => {
    sendEvent({ category: gaEventCategory, action: 'wishlist_click' });
    showDialog(WishlistDialog);
  };

  return (
    <Box className="relative mt-6 flex-col items-center justify-between overflow-hidden bg-primary-300 p-4 pb-6 dark:bg-primary-300 md:flex-row">
      <div className="flex flex-col items-center md:mr-10 md:flex-row">
        <Image
          alt="Adicione um termo na lista de desejos"
          className="md:ml-5"
          height={83}
          src={`${APP.LOCAL_IMAGE_PATH}/features/wishlist/wishlist-cta-icon.svg`}
          width={114}
          aria-hidden
        />
        <div className="mt-2 md:ml-8 md:mt-0">
          <Heading
            as="span"
            className="mb-2 text-neutral-high-100"
            size="size5"
          >
            {title}
          </Heading>
          <Text className="text-neutral-high-100">{description}</Text>
        </div>
      </div>
      <Button
        className="mt-4 w-full border-neutral-high-200 bg-neutral-high-100 hover:border-neutral-high-300 dark:bg-neutral-high-200 md:mr-4 md:mt-0 md:w-unset"
        iconLeft={<Icon name="heart" />}
        size="size2"
        type="secondary-stroke"
        onClick={onWishlistButtonClick}
      >
        {placeholder('actions.openWishlist')}
      </Button>
      <Image
        alt="Adicione um termo na lista de desejos"
        className="absolute -bottom-px left-0 w-full object-cover md:h-10"
        height={12}
        src={`${APP.LOCAL_IMAGE_PATH}/features/wishlist/wishlist-cta-footer-884w.svg`}
        width={375}
        aria-hidden
      />
    </Box>
  );
};

WishlistSuggestion.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  gaEventCategory: PropTypes.string.isRequired,
};

export default WishlistSuggestion;
